// deps
import styled, { css } from "styled-components";

// internal-deps
import { ChevronRightIcon } from "@cart-ui/components/address-widget-top/components/icons";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import IrctcIcon from "../address-widget-top/components/icons/IrctcIcon";

const SIDE_PADDING = {
    WITHOUT_STAMP: "90px",
    EXTRA_WITH_STAMP: "68px",
};

// base styles
const flexStyles = css`
    display: flex;
`;

const textOverflowStyles = css`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

const buttonResetStyles = css`
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    appearance: none;
    -webkit-appearance: none;
`;

// styled components
export const ContainerStyled = styled.div`
    ${flexStyles}
    ${textOverflowStyles}
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 0 2px;
    width: 100vw;
    height: 100%;
`;

export const ContentStyled = styled.div<{ $isRtbXpEnabled?: boolean }>`
    ${textOverflowStyles}
    ${({ $isRtbXpEnabled }) =>
        $isRtbXpEnabled &&
        css`
            z-index: 1;
        `}
`;

export const TitleStyled = styled.div`
    ${flexStyles}
    ${textOverflowStyles}
    align-items: center;
    margin-top: ${(props) => props.theme.spacing.xxxSmall};
    max-width: 100%;
`;

export const TitleTextStyled = styled(Text)`
    ${textOverflowStyles}
`;

export const SubtitleStyled = styled.div`
    ${flexStyles}
    ${textOverflowStyles}
    margin-top: ${(props) => props.theme.spacing.xxxSmall};
`;

export const StyledDeliveryAddressIcon = styled(GenericIcon)`
    margin-right: ${(props) => props.theme.spacing.xxSmall};
`;

export const AddressIconStyled = styled.button`
    ${flexStyles}
    ${buttonResetStyles}
    align-self: flex-end;
`;

export const AnnotationContainerStyled = styled.div`
    ${flexStyles}
    max-width: 100%;
`;

export const AddressInfoContainerStyled = styled.div`
    ${flexStyles}
    ${textOverflowStyles}
    ${(props) => props.theme.typography["V2.body3.neutral.regular"]}
`;

export const SeparatorStyled = styled.div<{ shouldApplyInverseColor?: boolean }>`
    color: ${(props) =>
        props.shouldApplyInverseColor
            ? props.theme.colors[props.theme.colorMode].text_inverse_Low_Emphasis
            : props.theme.colors[props.theme.colorMode].text_Low_Emphasis};
    margin: 0 ${(props) => props.theme.spacing.xxSmall};
`;

export const ToingHeaderSeparatorStyled = styled.div<{ $isRtbXpEnabled?: boolean }>`
    color: ${(props) =>
        props.$isRtbXpEnabled
            ? props.theme.colors[props.theme.colorMode].text_Highest_Emphasis
            : props.theme.colors[props.theme.colorMode].text_inverse_High_Emphasis};
    margin: 0 ${(props) => props.theme.spacing.xxSmall};
`;

export const AddressInfoStyled = styled(Text)`
    ${textOverflowStyles}
    margin-top: 1px;
`;

export const ChevronRightIconStyled = styled(ChevronRightIcon)`
    transform: rotate(90deg);
`;

export const IrctcIconStyled = styled(IrctcIcon)`
    margin-right: ${(props) => props.theme.spacing.xxSmall};
`;

export const CartHeaderContentContainer = styled.div<{ hasStamp?: boolean; isToing?: boolean }>((props) => {
    if (props?.isToing) {
        return {
            display: "flex",
            maxWidth: "70%",
        };
    }

    return {
        display: "flex",
        maxWidth: `calc(100vw - ${SIDE_PADDING.WITHOUT_STAMP} - ${
            props?.hasStamp ? SIDE_PADDING.EXTRA_WITH_STAMP : "0px"
        })`,
    };
});
